import dayjs from "dayjs";
import { TruncatedText } from "@/components/common/text";
import { cn } from "@/utils/css";

export const LoadboardTime = ({ stop, fontSmall }) => {
    if (!stop) {
        return <div className={cn("text-cm-p-text-secondary", { "text-xs": fontSmall })}>-</div>;
    }
    const earlyTime = stop.earlyTime ? dayjs(stop.earlyTime, "HH:mm").format("h:mm A") : null;
    let lateTime = stop.lateTime ? dayjs(stop.lateTime, "HH:mm").format("h:mm A") : null;

    if (earlyTime === lateTime) {
        lateTime = null;
    }

    const timeText = earlyTime && lateTime ? `${earlyTime} - ${lateTime}` : earlyTime ? `${earlyTime}` : lateTime ? `${lateTime}` : "-";

    return (
        <TruncatedText
            as="div"
            className={cn("text-cm-p-text-secondary min-[1920px]:min-w-max", { "text-xs": fontSmall })}
        >
            {timeText}
        </TruncatedText>
    );
};
